import { useEffect, useRef } from "react";
import "./MultiPurpose.css";
import { useNavigate } from "react-router-dom";

const MultiPurpose = ({
  title = "Notice",
  message = "",
  yesText = "YES",
  noText = "NO",
  onYes,
  onNo,
  showYesLink = false,
  yesLink = "",
  showNoLink = false,
  noLink = "",
  onClose,
  hideNo = false,
  useHTML = false,
}) => {
  const navigate = useNavigate();
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  return (
    <div className="multipurpose">
      <div className="multipurpose-content" ref={modalRef}>
        <div className="mp-close-button">
          <button
            onClick={() => {
              if (onNo) onNo();
              if (onClose) onClose();
              navigate(noLink);
            }}
          >
            &#10006;
          </button>
        </div>
        <div className="multipurpose-title">
          <strong>{title}</strong>
        </div>
        <div className="multipurpose-main">
          {useHTML ? (
            <div dangerouslySetInnerHTML={{ __html: message }} />
          ) : (
            message
          )}
        </div>
        <div className="multipurpose-sub">
          {showNoLink ? (
            <div className="multipurpose-no">
              <button
                onClick={() => {
                  if (onNo) onNo();
                  if (onClose) onClose();
                  if (
                    noLink.startsWith("http://") ||
                    noLink.startsWith("https://")
                  ) {
                    window.location.href = noLink;
                  } else {
                    navigate(noLink);
                  }
                }}
              >
                {noText}
              </button>
            </div>
          ) : (
            !hideNo && (
              <div className="multipurpose-no">
                <button onClick={onNo}>{noText}</button>
              </div>
            )
          )}
          {showYesLink ? (
            <div className="multipurpose-yes">
              <button
                onClick={() => {
                  if (onYes) onYes();
                  if (onClose) onClose();
                  if (
                    yesLink.startsWith("http://") ||
                    yesLink.startsWith("https://")
                  ) {
                    window.location.href = yesLink;
                  } else {
                    navigate(yesLink);
                  }
                }}
              >
                {yesText}
              </button>
            </div>
          ) : (
            <div className="multipurpose-yes">
              <button onClick={onYes}>{yesText}</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MultiPurpose;
